import React from 'react';
import '../public/css/Contact.css';
import { Card, Container, Divider, Grid, Header, Image } from 'semantic-ui-react';
import contactImage1 from '../public/image/Contact Page Image 1.png';
import contactImage2 from '../public/image/Contact Page Image 2.png';
import contactImage3 from '../public/image/Contact page image 3.png';
import contactImage4 from '../public/image/Contact page image 4.png';

const Contact = () => (
	<Container className="contact-container">
		<Divider hidden />
		<Header as="h1" textAlign="center" className="contact-header">
			Contact
		</Header>
		<Divider hidden />
		<Grid divided="vertically" stackable centered>
			<Grid.Row>
				<Grid.Column width={4}>
					<Card fluid color="blue" className="contact-card">
						<Image src={contactImage1} wrapped ui={false} />
					</Card>
				</Grid.Column>
				<Grid.Column width={4}>
					<Card fluid color="green" className="contact-card">
						<Image src={contactImage2} wrapped ui={false} />
					</Card>
				</Grid.Column>
				<Grid.Column width={4}>
					<Card fluid color="yellow" className="contact-card">
						<Image src={contactImage3} wrapped ui={false} />
					</Card>
				</Grid.Column>
				<Grid.Column width={4}>
					<Card fluid color="orange" className="contact-card">
						<Image src={contactImage4} wrapped ui={false} />
					</Card>
				</Grid.Column>
				<p>
					Photographs from the work <span className="text-italic">Anjuman-i Nāṣirī</span> (Tehran, ca.
					1882-96) by Mīrzā Ibrāhīm Khan Madāʾih Nigār Tafrīshī
				</p>
			</Grid.Row>
			<Grid.Row columns={1}>
				<Grid.Column width={12}>
					<Card fluid color="red" className="contact-card">
						<Card.Content>
							<Card.Header />
							<Card.Description>
								For any questions, comments, corrections, or other matters please send an email to k
								[dot] lewis [dot] schwartz [at] gmail [dot] com with “Persian Tadhkira Project” listed
								as the subject.
							</Card.Description>
						</Card.Content>
					</Card>
					<Divider hidden />
				</Grid.Column>
			</Grid.Row>
		</Grid>
		<Divider hidden />
	</Container>
);
export default Contact;
